function createIcon({ iconName, className, additionalClassName }) {
  const element = document.createElement('div');
  element.classList.add(className);
  element.classList.add(`${className}--${iconName}`);

  if (additionalClassName) {
    element.classList.add(additionalClassName);
  }

  return element;
}

export default createIcon;
